import { Button, Form, Input } from 'antd';
import React, { useEffect } from 'react';
import { useAuthors } from './AuthorsState';
import { useForm } from 'antd/es/form/Form';

function Edit(props) {
    let { updateCat, ed } = useAuthors()
    let [form] = useForm()

    useEffect(() => {
        form.setFieldsValue(ed)
    }, [ed])
    return (
        <Form
            form={form}
            name="basic"
            labelCol={{
                span: 24,
            }}
            wrapperCol={{
                span: 24,
            }}
            onFinish={updateCat}
            autoComplete="off"
        >
            <Form.Item
                name="id"
                hidden={true}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Avtor nomi"
                name="fullname"
                rules={[
                    {
                        required: true,
                        message: "Iltimos to'ldiring!",
                    },
                ]}
            >
                <Input />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">
                    Saqlash
                </Button>
            </Form.Item>

        </Form>
    );
}

export default Edit;